module.exports = __webpack_public_path__ + "fonts/boxicons.2722ed7e.eot";